// src/App.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { UserProvider } from "./components/context/UserContext";

import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import Home from "./components/pages/Home";
import HeroSection from "./components/HeroSection";
import TutorSubmission from "./components/pages/TutorSubmission";
import TutorSubmissionRegular from "./components/pages/TutorSubmissionRegular";
import UserLogin from "./components/pages/UserLogin";
import ForgotPassword from "./components/pages/ForgotPassword";
import ResetPassword from "./components/pages/reset-password";
import AdminLogin from "./components/pages/AdminLogin";
import AdminDash from "./components/pages/AdminDashboard";
import StudentUserProfile from "./components/pages/StudentUserProfile";
import TutorUserProfile from "./components/pages/TutorUserProfile";
import TutorProfile from "./components/pages/TutorProfile";
import TutorProfileEdit from "./components/pages/TutorProfileEdit";
import ShareProfile from "./components/pages/ShareProfile";
import TuitionPost from "./components/pages/TuitionSubmission";
import TuitionBoard from "./components/pages/TuitionBoard";
import TuitionProfile from "./components/pages/TuitionProfile";
import TutorBoard from "./components/pages/TutorBoard";
import Package from "./components/pages/Package";
import Checkout from "./components/pages/Checkout";
import Legal from "./components/pages/Legal";
import About from "./components/pages/About";

import "./App.css";

function App() {
  const [apiData, setApiData] = useState(null); // State to store API response

  useEffect(() => {
    const apiUrl = "https://tn.server.goatteachers.com"; // Base URL to the Tutor Network server

    // Make the API request using Axios
    axios
      .get(`${apiUrl}/api/tutors`) // Replace with your actual endpoint
      .then((response) => {
        setApiData(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching data!", error);
      });
  }, []);

  return (
    <UserProvider>
      <Router>
        <Header />

        <Routes>
          {/* Landing */}
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <Home />
              </>
            }
          />

          {/* Tutor */}
          <Route path="/tutor/profile" element={<TutorUserProfile />} />
          <Route path="/tutor/profile/edit" element={<TutorProfileEdit />} />
          <Route
            path="/tutor/me/edit"
            element={<Navigate to="/tutor/profile/edit" replace />}
          />
          <Route path="/tutor/:id" element={<TutorProfile />} />
          <Route path="/tutor-submission" element={<TutorSubmission />} />
          <Route
            path="/tutor-submission-regular"
            element={<TutorSubmissionRegular />}
          />
          <Route path="/tutor-board" element={<TutorBoard />} />

          {/* Tuition */}
          <Route path="/post-tuition" element={<TuitionPost />} />
          <Route path="/tuition-board" element={<TuitionBoard />} />
          <Route path="/tuition/:id" element={<TuitionProfile />} />

          {/* Payment */}
          <Route path="/packages" element={<Package />} />
          <Route path="/checkout" element={<Checkout />} />

          {/* Auth */}
          <Route path="/login" element={<UserLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Student */}
          <Route path="/student/profile" element={<StudentUserProfile />} />

          {/* Share */}
          <Route path="/share-profile" element={<ShareProfile />} />
          <Route path="/share-profile/:id" element={<ShareProfile />} />

          {/* Admin */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/tn-admin" element={<AdminDash />} />

          {/* Legal */}
          <Route path="/legal" element={<Legal />} />

          <Route path="/about" element={<About />} />
        </Routes>

        {/* <Footer /> */}
      </Router>
    </UserProvider>
  );
}

export default App;
